import getCalendarPickerStore from './getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { Calendar, getDefaultCalendar } from 'owa-calendar-cache';
import { getCalendars, isSelectedCalendar } from 'owa-calendar-surface-calendars-store';

export default function getSelectedCalendarsForUser(
    scenarioId: CalendarPickerScenarioId,
    userIdentity: string
): Calendar[] {
    const defaultCalendar = getDefaultCalendar(userIdentity);
    if (!defaultCalendar) {
        return [];
    }
    const calendarPickerStore = getCalendarPickerStore(scenarioId);
    const condensedViewCalendars = calendarPickerStore.condensedViewCalendars.get(userIdentity);

    const viewableCalendars = getCalendars().filter(calendar => {
        const isNonDefaultCalendar = calendar.id.id !== defaultCalendar.id.id;
        const isMatchingUser = calendar.id.mailboxInfo.userIdentity === userIdentity;
        const isInCondensedViewCalendars =
            condensedViewCalendars.filter(calId => calId === calendar.id.id).length > 0;
        return (
            (isSelectedCalendar(calendar) || isInCondensedViewCalendars) &&
            isNonDefaultCalendar &&
            isMatchingUser
        );
    });

    return defaultCalendar
        ? viewableCalendars
            ? [defaultCalendar, ...viewableCalendars]
            : [defaultCalendar]
        : [];
}
